module.exports = __webpack_public_path__ + "static/img/footer-logo.56977434.png";